

export const currencyFormatter = (amount)=>{
    const IntAmount = Number(amount);
    return IntAmount.toLocaleString('en-US', {
    style: 'currency',
    currency: 'BDT',
  })
}